'use client'

import { Intercom } from 'react-live-chat-loader'

const IntercomClient = (): JSX.Element => {
  return <Intercom color="#FF8E00" />
}

export default IntercomClient
